module.exports = "<app-busca (found)=\"onFound($event)\"></app-busca>\n\n<app-lista\n  *ngFor=\"let item of helps\"\n  [help]=\"item\"\n>\n</app-lista>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/help/help.component.html
// module id = 182
// module chunks = 1